<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Welcome Admin!</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Edit Applicant's info</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                    <div class="card-header">
                        <h4 class="card-title mb-0">General Info</h4>
                    </div>
                    <div class="card-body">
                        <form action="#">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Salutation</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">First Name</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>   
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Middle Name</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Last Name</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Suffix</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>      
                            <div class="col-sm-12">                    
                              <div class="form-group">
                                <label>Gender:</label>
                                <select class="select form-control">
                                  <option>-- Select --</option>
                                  <option value="1">Female</option>
                                  <option value="2">Male</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label>Language:</label>
                                <select class="select form-control">
                                  <option>-- Select --</option>
                                  <option value="1">Arabic</option>
                                  <option value="2">English</option>
                                  <option value="3">German</option>
                                </select>
                              </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                    <div class="card-header">
                        <h4 class="card-title mb-0">General Info</h4>
                    </div>
                    <div class="card-body">
                        <form action="#">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Salutation</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">First Name</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>   
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Middle Name</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Last Name</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Suffix</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>      
                            <div class="col-sm-12">                    
                              <div class="form-group">
                                <label>Gender:</label>
                                <select class="select form-control">
                                  <option>-- Select --</option>
                                  <option value="1">Female</option>
                                  <option value="2">Male</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label>Language:</label>
                                <select class="select form-control">
                                  <option>-- Select --</option>
                                  <option value="1">Arabic</option>
                                  <option value="2">English</option>
                                  <option value="3">German</option>
                                </select>
                              </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                    <div class="card-header">
                        <h4 class="card-title mb-0">Contact Details</h4>
                    </div>
                    <div class="card-body">
                        <form action="#">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Mobile Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Home Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Email Address</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>   
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Business Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                    <div class="card-header">
                        <h4 class="card-title mb-0">Contact Details</h4>
                    </div>
                    <div class="card-body">
                        <form action="#">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Mobile Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Home Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Email Address</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>   
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Business Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                    <div class="card-header">
                        <h4 class="card-title mb-0">Social Networks</h4>
                    </div>
                    <div class="card-body">
                        <form action="#">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">LinkedIn Profile URL</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Facebook Profile URL</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>   
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Xing Profile Name</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Skype Id</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                    <div class="card-header">
                        <h4 class="card-title mb-0">Contact Details</h4>
                    </div>
                    <div class="card-body">
                        <form action="#">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Mobile Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Home Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Email Address</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>   
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Business Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                    <div class="card-header">
                        <h4 class="card-title mb-0">Contact Details</h4>
                    </div>
                    <div class="card-body">
                        <form action="#">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Mobile Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Home Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Email Address</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>   
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Business Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                    <div class="card-header">
                        <h4 class="card-title mb-0">Contact Details</h4>
                    </div>
                    <div class="card-body">
                        <form action="#">
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Mobile Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Home Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Email Address</label>
                                <input class="form-control" type="text">
                              </div>
                            </div>   
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label class="col-form-label">Business Phone</label>
                                <input class="form-control" type="text">
                              </div>
                            </div> 
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  </div>
</template>
<script>
  import LayoutHeader from '@/components/layouts/Header.vue'
  import LayoutSidebar from '@/components/layouts/Sidebar.vue'
  import Vue from 'vue'
  export default {
    components: {
      LayoutHeader,
      LayoutSidebar,
    },
    mounted() {
      
    },
    methods: {
    },
    name: 'editApplicant'
  }
</Script>


// WEBPACK FOOTER //
// src/components/editApplicant.vue